module.exports = __webpack_public_path__ + "img/icon-start-plan.2cb818f6.svg";